module.exports = __webpack_public_path__ + "static/media/TMDB-movies-app.98ed1bca.png";